import { DiplomaLanguageEnum, StudentDiplomasQuery } from 'core/graphql';

/**
 * One issued diploma CERTIFICATE (the PDF staff attach in the ERP) — not the
 * `graduationProject` / дипломный проект of the lesson tabs.
 *
 * A student normally has two rows for the same course: one PL, one EN.
 */
export interface IMyDiploma {
  id: string;
  language: DiplomaLanguageEnum;
  groupName: string;
  courseName: string;
  /** Original upload filename — may be empty on older rows. */
  originalName: string;
  sizeBytes: number | null;
  /** ISO timestamp of when the file was attached, or null. */
  issuedAt: string | null;
}

type DiplomaRow = StudentDiplomasQuery['myDiplomas'][number];

const transformDiploma = (row: DiplomaRow): IMyDiploma => ({
  id: row.id,
  language: row.language,
  groupName: row.groupName || '',
  courseName: row.courseName || '',
  originalName: row.originalName || '',
  sizeBytes: row.sizeBytes ?? null,
  issuedAt: row.issuedAt ?? null,
});

/**
 * Server order is preserved (`-uploaded_at, -pk` → newest first, deterministic
 * tiebreak) — deliberately not re-sorted on the client.
 */
export const transformMyDiplomas = (data: StudentDiplomasQuery | undefined): IMyDiploma[] =>
  (data?.myDiplomas ?? []).map(transformDiploma);
